module.exports = __webpack_public_path__ + "assets/img/loading.d8367004.svg";